
/**
 * Match the product added to cart size value to the size dropdown option
 * implemented: layout\theme.liquid
 */
 document.addEventListener("DOMContentLoaded", function () {

    // cart page
    if (window.location.href.includes("cart")) {
        setTimeout(matchSizeSelection, 1000)
    }


    // product page
    document.addEventListener('cart:updated', function(evt) {

        const cart_drawer = document.querySelector('cart-drawer')
        if(!cart_drawer){
        return console.log('Cant find cart drawer DOM element')
        }

        setTimeout(matchSizeSelection, 1500)

    });


    function matchSizeSelection(){
    const sizesDropdown = document.querySelectorAll('[data-js="select-cart-cane-length"]')
    // const sizesDropdown = document.querySelectorAll('.cart-drawer [data-js="select-cart-cane-length"]')

    if(sizesDropdown.length  === 0){
        return console.log('Cant find sizesDropdown DOM elements')
    }

    sizesDropdown.forEach(dropdown =>{
        const dropdown_key = dropdown.getAttribute('data-js-cane-length-select-key')
        const selected_size = document.querySelector(`[data-js-cane-length-value-key='${dropdown_key}']`)
        
        const options = dropdown.querySelectorAll("option");

        if(options.length === 0){
            return console.log('Cant find options DOM elements')
        }

        options.forEach(option => {
                // standard size will be selected if no condition is matched
                if(option.value === `*${selected_size.innerHTML}*`){
                    option.setAttribute('selected', true)
                }  
            })

        })
    }
 })





   
